import axios from "axios";

export const http91 = axios.create({
  baseURL: process.env.REACT_APP_VECTOR_ENDPOINT,
  // headers: `Bearer ${localStorage.getItem("access_token")}` as any
});

http91.interceptors.request.use((req) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});


// Add a response interceptor
http91.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (error.response) {
      // Check if the status code is 401 (Unauthorized)
      if (error.response.status === 401) {
        try {
          // Refresh the access token
          const newToken = await refreshAccessToken();

          // Retry the failed request with the new token
          const config = error.config;
          config.headers.Authorization = `Bearer ${newToken}`;
          return axios(config);
        } catch (refreshError) {
          if (localStorage.getItem("clientName") === 'Veedalifescience') {
            window.location.href = '/login?env=Veedalifescience'
          } else if (localStorage.getItem('clientName') === 'Amspec_clone') {
            window.location.href = '/login?env=AmSpec'
          } else {
            window.location.href = '/login'
          }
          // localStorage.clear()
          localStorage.removeItem('access_token');
          localStorage.removeItem('announcements');
          //localStorage.removeItem('clientName');
          localStorage.removeItem('default_label');
          localStorage.removeItem('default_questions');
          localStorage.removeItem('feature-flag');
          localStorage.removeItem('firstName');
          localStorage.removeItem('isLogged');
          localStorage.removeItem('lastActivity');
          localStorage.removeItem('lastName');
          localStorage.removeItem('loginTime');
          localStorage.removeItem('logos');
          localStorage.removeItem('permissions');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('username');
          localStorage.removeItem('lastBotQuestion');
          localStorage.removeItem('botId');
          localStorage.removeItem("wrongAttempt");
          localStorage.removeItem("attempt");
          localStorage.removeItem('handler_name_exist');
          localStorage.removeItem("false_attempt");
          localStorage.removeItem("user_name_attempts")
          localStorage.removeItem("chatUserName");
          localStorage.removeItem("chat_access_token");
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);



const refreshAccessToken = async () => {
  try {
    const tokenRefreshEndpoint = `${process.env.REACT_APP_API_ENDPOINT}getTokenUsingRefreshToken`;
    const refreshToken = localStorage?.getItem("refresh_token")
    if (refreshToken) {
      const response = await axios.post(tokenRefreshEndpoint, {
        refresh_token: refreshToken,
        client_env: localStorage.getItem("clientName")
      });
      if (response?.data?.error) {
        throw response?.data?.error
      }
      const newToken = response.data.access_token;
      const refresh_token = response.data.refresh_token;
      localStorage.setItem('access_token', newToken);
      localStorage.setItem('refresh_token', refresh_token);
      return newToken;
    }

  } catch (error) {
    throw error;
  }
};